import { doParseDate } from '../../assets/helpers/utils/format-date-to-date-and-time.ts';
export type TooltipFormatterArgs = {
  value: number | null;
  axisValue: string;
  timeLabel: string;
  dataIndex: number;
};

export const pad2 = (n: number) => String(n).padStart(2, '0');

export const formatLocalAxisKey = (d: string) => {
  const parsed = doParseDate(d);

  return `${parsed.getFullYear()}-${pad2(parsed.getMonth() + 1)}-${pad2(parsed.getDate())} ${pad2(parsed.getHours())}:${pad2(parsed.getMinutes())}`;
};

export const formatTickDay = (d: string) => {
  const parsed = doParseDate(d);
  return pad2(parsed.getDate());
};

export const formatTooltipDate = (d: string) => {
  const parsed = doParseDate(d);
  return `${pad2(parsed.getDate())}.${pad2(parsed.getMonth() + 1)}.${parsed.getFullYear()}`;
};

export const formatTooltipTime = (d: string) => {
  const parsed = doParseDate(d);

  return parsed.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const defaultTooltipFormatter = ({
                                   value,
                                   timeLabel,
                                 }: TooltipFormatterArgs) => `${value ?? '—'} ${timeLabel}`;